// extracted by mini-css-extract-plugin
export var icon = "LinkWithIcon-module--icon--84b0a";
export var link = "LinkWithIcon-module--link--5f69b";
export var reversed = "LinkWithIcon-module--reversed--6ae39";